export default [
  { path: '/system/WechatResponseConfig', name: 'WechatResponseConfig', component: resolve => require(['@/views/system/WechatResponseConfig'], resolve)}
]



// WEBPACK FOOTER //
// ./src/config/router/system.js